<template>
  <div>
    <v-app-bar
      app
      color="primary"
      dark
      class="px-15 d-flex align-center justify-center"
    >
      <v-toolbar-title>
        <v-img src="@/assets/playeras/logoNami.png" max-width="100px" />
      </v-toolbar-title>
    </v-app-bar>

    <div class="catalog-container">
      <div class="catalog">
        <div
          v-for="(image, index) in images"
          :key="index"
          class="catalog-item"
          @click="openModal(image.src)"
        >
          <img
            :src="image.src"
            :alt="image.name"
            class="lazy-image"
          />
          <p>{{ image.name }}</p>
        </div>
      </div>
    </div>

    <!-- Contact Button -->
    <v-btn color="secondary" class="contact-button" @click="contactModal = true">
      Contacto / Hacer Pedido
    </v-btn>

    <!-- Image Modal -->
    <v-dialog v-model="imageModal" max-width="600px">
      <v-card>
        <v-card-actions>
          <v-btn icon @click="imageModal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
        <v-img :src="modalImage" max-height="500px" contain />
      </v-card>
    </v-dialog>

    <!-- Contact Modal -->
    <v-dialog v-model="contactModal" max-width="500px">
      <v-card>
        <v-card-title>Contacto / Hacer Pedido</v-card-title>
        <v-card-text>
          <v-form ref="contactForm">
            <v-text-field
              v-model="contactForm.name"
              label="Nombre"
              required
            ></v-text-field>
            <v-text-field
              v-model="contactForm.email"
              label="Correo Electrónico"
              type="email"
              required
            ></v-text-field>
            <v-textarea
              v-model="contactForm.message"
              label="Mensaje"
              rows="4"
              required
            ></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="submitContactForm">Enviar</v-btn>
          <v-btn text @click="contactModal = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import emailjs from 'emailjs-com';

const imagesContext = require.context('@/assets/playeras/', false, /\.(png|jpe?g|svg)$/);

export default {
  name: 'Catalogo',
  data() {
    return {
      images: imagesContext.keys().map(key => ({
        name: key.replace('./', '').split('.')[0],
        src: imagesContext(key)
      })),
      contactModal: false,
      imageModal: false,
      modalImage: '',
      contactForm: {
        name: '',
        email: '',
        message: ''
      }
    };
  },
  methods: {
    openModal(imageSrc) {
      this.modalImage = imageSrc;
      this.imageModal = true;
    },
    async submitContactForm() {
      if (this.contactForm.name && this.contactForm.email && this.contactForm.message) {
        try {
          const serviceID = 'your_service_id'; // Reemplaza con tu Service ID de EmailJS
          const templateID = 'your_template_id'; // Reemplaza con tu Template ID de EmailJS
          const userID = 'your_user_id'; // Reemplaza con tu User ID de EmailJS

          const templateParams = {
            name: this.contactForm.name,
            email: this.contactForm.email,
            message: this.contactForm.message,
          };

          await emailjs.send(serviceID, templateID, templateParams, userID);
          alert('Mensaje enviado con éxito.');
          this.contactModal = false;
          this.contactForm = { name: '', email: '', message: '' };
        } catch (error) {
          console.error('Error:', error);
          alert('Error al enviar el mensaje. Inténtelo de nuevo.');
        }
      } else {
        alert('Por favor, complete todos los campos.');
      }
    }
  }
};
</script>

<style scoped>
.catalog-container {
  margin-top: 32px;
  padding: 16px;
}

.catalog {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
}

.catalog-item {
  text-align: center;
  transition: transform 0.3s ease;
  cursor: pointer;
}

.catalog-item:hover {
  transform: scale(1.1);
}

.lazy-image {
  max-width: 50%; /* Reduce the size to half */
  height: auto;
}

.contact-button {
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: 1000;
}
</style>